import { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import axios from "axios";
import Loader from "./Loader";
import { ensureValidToken } from "../utils/authService";
import "../styles/AccessModal.css";

const SharedCard = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const [requiresAccess, setRequiresAccess] = useState(false);
  const [accessRequested, setAccessRequested] = useState(false);

  // Determine if this is a holder share
  const isHolderShare = searchParams.get('from') === 'holder' || 
                       location.state?.isHolderShare;

  const requestAccess = async () => {
    try {
      const accessToken = await ensureValidToken();
      if (!accessToken) {
        navigate("/login");
        return;
      }
      await axios.post(
        "https://api.nexcard.co.in/api/cards/request/",
        { card: id },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      setAccessRequested(true);
    } catch (error) {
      console.error("Access request failed:", error);
      alert("Failed to request access. Please try again.");
    }
  };

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const accessToken = await ensureValidToken();
        
        if (!accessToken) {
          // FIX: Pass the current path as the redirect destination
          const currentPath = `/shared-card/${id}`;
          navigate('/login', { 
            state: { 
              from: currentPath, // This is the key fix!
              requireCard: true,
              isHolderShare: isHolderShare
            } 
          });
          return;
        }

        const response = await axios.get(`https://api.nexcard.co.in/api/cards/${id}/`, {
          headers: { Authorization: `Bearer ${accessToken}` }
        });

        if (isHolderShare && !response.data.can_access) {
          setRequiresAccess(true);
        } else {
          navigate(`/card-details/${id}`);
        }
      } catch (error) {
        console.error("Error checking access:", error);
        navigate('/home-my-cards', { state: { error: "Couldn't load shared card" } });
      } finally {
        setIsLoading(false);
      }
    };

    checkAccess();
  }, [id, navigate, location, isHolderShare]);

  if (isLoading) return <Loader />;

  if (requiresAccess) {
    return (
      <div className="access-modal-overlay">
        <div className="access-modal">
          {accessRequested ? (
            <>
              <h2>Access Requested</h2>
              <p>You'll be notified when the owner approves your request</p>
              <button 
                className="modal-btn primary"
                onClick={() => navigate('/home-my-cards')}
              >
                Done
              </button>
            </>
          ) : (
            <>
              <h2>Permission Required</h2>
              <p>You need the owner's approval to view this card</p>
              <div className="modal-btn-group">
                <button 
                  className="modal-btn primary"
                  onClick={requestAccess}
                >
                  Request Access
                </button>
                <button 
                  className="modal-btn secondary"
                  onClick={() => navigate('/home-my-cards')}
                >
                  Cancel
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  return null;
};

export default SharedCard;